import { useState } from 'react';
import Layout from '@/components/feature/Layout';
import JsonLd from '@/components/base/JsonLd';
import { topics } from '@/mocks/community';

const covers = [
  'https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20fierce%20characters%20in%20a%20dynamic%20battle%20pose%20with%20glowing%20embers%20and%20energy%20effects%2C%20warm%20red%20and%20orange%20palette%2C%20dramatic%20action%20scene%2C%20flat%20vibrant%20anime%20art%20style%2C%20epic%20and%20intense%20mood%2C%20clean%20composition%20with%20soft%20light%20particles&width=900&height=560&seq=topic-battle&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20a%20peaceful%20countryside%20at%20dusk%2C%20quiet%20scenery%20with%20warm%20light%20and%20a%20character%20sitting%20alone%20under%20a%20tree%2C%20soft%20pastel%20peach%20and%20amber%20tones%2C%20healing%20and%20gentle%20mood%2C%20flat%20anime%20art%20style%2C%20calm%20and%20comforting%20atmosphere%2C%20clean%20composition&width=900&height=560&seq=topic-heal&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20a%20cheerful%20character%20holding%20a%20book%20beside%20a%20blooming%20cherry%20tree%2C%20warm%20spring%20light%2C%20coral%20and%20soft%20green%20palette%2C%20cozy%20reading%20atmosphere%2C%20flat%20vibrant%20anime%20art%20style%2C%20fresh%20and%20optimistic%20mood%2C%20clean%20composition%20with%20floating%20petals&width=900&height=560&seq=topic-news&orientation=landscape',
];

export default function Topics() {
  const [expanded, setExpanded] = useState<number | null>(null);

  return (
    <Layout>
      <JsonLd
        data={{
          '@context': 'https://schema.org',
          '@type': 'CollectionPage',
          name: '羞羞动漫社专题文章',
          description: '羞羞动漫社的深度专题文章，涵盖热血番演进、治愈系洞察与新番速递等话题。',
          url: 'https://mangafor.github.io/topics',
          itemListElement: topics.map((t, i) => ({
            '@type': 'ListItem',
            position: i + 1,
            name: t.title,
          })),
        }}
      />

      <section className="relative overflow-hidden bg-foreground-900 pt-24 md:pt-28 pb-12 md:pb-16 text-center">
        <div className="relative z-10 mx-auto w-full max-w-7xl px-4 md:px-6">
          <h1 className="font-heading text-3xl md:text-5xl text-background-50">专题文章</h1>
          <p className="mx-auto mt-3 max-w-xl text-sm md:text-base text-background-100/90">
            用更有深度的内容连接彼此，从热血番演进到治愈系洞察，一起慢下来读点好东西。
          </p>
        </div>
      </section>

      <section className="mx-auto w-full max-w-5xl px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col gap-8">
          {topics.map((t, idx) => {
            const open = expanded === t.id;
            return (
              <article
                key={t.id}
                className="overflow-hidden rounded-2xl border border-background-200 bg-background-50"
              >
                <div className="flex flex-col md:flex-row">
                  <div className="md:w-2/5">
                    <img
                      src={covers[idx % covers.length]}
                      alt={t.title}
                      className="h-48 w-full object-cover object-center md:h-full"
                    />
                  </div>
                  <div className="flex flex-1 flex-col p-5 md:p-6">
                    <span className="inline-flex w-fit items-center rounded-full bg-primary-100 px-3 py-0.5 text-xs font-medium text-primary-700">
                      {t.category}
                    </span>
                    <h2 className="mt-3 text-lg md:text-xl font-bold leading-snug text-foreground-950">{t.title}</h2>
                    <p className="mt-2 text-sm text-foreground-600">{t.summary}</p>
                    <div className="mt-3 flex flex-wrap items-center gap-4 text-xs text-foreground-500">
                      <span><i className="ri-eye-line mr-1"></i>{t.reads.toLocaleString()} 阅读</span>
                      <span>{t.date}</span>
                    </div>
                    <button
                      type="button"
                      onClick={() => setExpanded(open ? null : t.id)}
                      className="mt-4 inline-flex w-fit whitespace-nowrap items-center gap-1.5 rounded-md bg-background-100 px-4 py-2 text-sm font-semibold text-primary-700 hover:bg-primary-100 transition-colors"
                    >
                      {open ? '收起正文' : '阅读全文'}
                      <i className={`${open ? 'ri-arrow-up-line' : 'ri-arrow-down-line'}`}></i>
                    </button>
                  </div>
                </div>
                {open && (
                  <div className="border-t border-background-200 px-5 py-5 md:px-6">
                    <div className="space-y-4 text-sm md:text-base leading-relaxed text-foreground-800">
                      {t.body.map((para, i) => (
                        <p key={i}>{para}</p>
                      ))}
                    </div>
                  </div>
                )}
              </article>
            );
          })}
        </div>
      </section>
    </Layout>
  );
}